import { render, staticRenderFns } from "./yundong.vue?vue&type=template&id=8ae02d50&scoped=true"
import script from "./yundong.vue?vue&type=script&lang=ts"
export * from "./yundong.vue?vue&type=script&lang=ts"
import style0 from "./yundong.vue?vue&type=style&index=0&id=8ae02d50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae02d50",
  null
  
)

export default component.exports